var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['root']},[_c('div',{class:_vm.$style['button'],style:({ backgroundColor: _vm.color })},[_c('p',{class:_vm.$style['text'],on:{"click":function($event){return _vm.$emit('view')}}},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }